module.exports = __webpack_public_path__ + "img/icon_notice.43fdc3ce.svg";